import { useState, useEffect } from 'react';
import { useStore } from 'Store';
import { t } from 'Locale';

function useCategories(orderedFavoriteList) {
    const { deviceStorageState, appManager } = useStore();
    const [categories, setCategories] = useState([]);
    const [configLoaded, setConfigLoaded] = useState(false);

    useEffect(() => {
        const fetchDeviceConfig = async () => {
            try {
                const categoriesResult = await appManager.api.getCategories(
                    deviceStorageState.language
                );

                const allChannelIds = [];
                let allFavoritesCount = 0;

                const tmpCategories = categoriesResult.categories.map((category) => {
                    // Channels object contains an
                    // array of channelIds and count of channels in favorites
                    const channels = category.channels.reduce(
                        (result, { channelId }) => {
                            result.channelIds.push(channelId);
                            allChannelIds.push(channelId);
                            if (orderedFavoriteList.indexOf(channelId) !== -1) {
                                allFavoritesCount++;
                                result.favoritesCount++;
                            }
                            return result;
                        },
                        { channelIds: [], favoritesCount: 0 }
                    );

                    return {
                        title: t(category.name),
                        value: String(category.id),
                        ...channels
                    };
                });

                tmpCategories.unshift({
                    title: t('COMMON.ALL'),
                    value: 'all_categories',
                    channelIds: allChannelIds,
                    favoritesCount: allFavoritesCount
                });

                setCategories(tmpCategories);
            } catch (error) {
                console.log(error);
            }

            setConfigLoaded(true);
        };

        fetchDeviceConfig();
    }, []);

    // If orderedFavoriteList changes, recompute favorites count
    useEffect(() => {
        if (categories.length > 0) {
            const tmpCategories = categories.map((category) => ({
                ...category,
                favoritesCount: category.channelIds.filter(
                    (channelId) => orderedFavoriteList.indexOf(channelId) !== -1
                ).length
            }));
            setCategories(tmpCategories);
        }
    }, [orderedFavoriteList]);

    return [configLoaded, categories];
}

export { useCategories };
